import React from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../components/website/navigation';
import { Footer } from '../components/website/footer';

export const NotFoundPage = () => {
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            {/* Navigation at top */}
            <Navigation />
            
            {/* Main content - grows to fill available space */}
            <div className="flex-1 flex items-center justify-center px-4">
                <div className="text-center max-w-2xl mx-auto">
                    {/* Large 404 visual indicator */}
                    <div className="mb-8">
                        <h1 className="text-9xl font-bold text-[#333] font-nunito mb-4">
                            404
                        </h1>
                    </div>
                    
                    {/* Error message */}
                    <h2 className="text-3xl md:text-4xl font-semibold text-gray-800 mb-6 font-nunito leading-tight">
                        Uh oh, the link you are looking for does not exist.
                    </h2>
                    
                    {/* Description */}
                    <p className="text-lg text-gray-600 mb-8 font-nunito leading-relaxed">
                        Please check the URL and try again, or return to our home page to find what you're looking for.
                    </p>
                    
                    {/* Call-to-action button */}
                    <Link 
                        to="/" 
                        className="inline-block font-raleway uppercase text-white bg-gradient-to-r from-primary to-primary-light py-4 px-8 tracking-wider text-sm font-medium rounded-full border-0 transition-all duration-500 hover:shadow-lg hover:scale-105 hover:-translate-y-1"
                    >
                        Back to Home Page
                    </Link>
                </div>
            </div>
            
            {/* Footer at bottom - full width */}
            <Footer />
        </div>
    );
};

export default NotFoundPage;